export default __webpack_public_path__ + "static/media/Type 15 cover.1026952f.jpg";